// extracted by mini-css-extract-plugin
export default {"input":"InputNumber_input__ZSqvJ"};